import React from 'react';

export const AboutStory = () => (
  <div className="max-w-4xl mx-auto mb-16">
    <div className="bg-white rounded-lg shadow-lg p-8 sm:p-12">
      <h3 className="text-2xl sm:text-3xl font-serif font-bold text-[#001B2A] mb-6">
        The Story
      </h3>

      <div className="space-y-6 text-base sm:text-lg text-gray-700 leading-relaxed">
        <p className="flex items-start gap-3">
          <span className="text-4xl font-serif text-[#7B1E2B] leading-none">"</span>
          <span className="flex-1">
            Born March 10th, 1959, in Norfolk, Virginia, Johnnie L Mayo's journey into the world of fashion began at Norview Senior High School, Class of '77.
          </span>
        </p>

        <p>
          While attending Norview, Johnnie took an elective called <strong>Distributive Education</strong> - a vocational training program that combined classroom instruction with part-time, on-the-job experience. This program was designed to prepare students for careers in marketing, merchandising, sales, and management by teaching practical business skills.
        </p>

        <p>
          <strong>His goal was clear:</strong> to learn how to operate a retail store in the fashion industry.
        </p>

        <div className="bg-[#E6D7B3]/20 border-l-4 border-[#7B1E2B] p-6 my-6 rounded-r-lg">
          <h4 className="font-serif font-bold text-xl text-[#001B2A] mb-3">The Defining Moment</h4>
          <p className="mb-4">
            Johnnie's first job was at a prestigious men's fashion store in downtown Norfolk called <em>Fashion's by Me and David</em>. Initially assigned to unpack stock, label, and price merchandise, his career took an unexpected turn on one fateful Saturday.
          </p>
          <p className="mb-4">
            While covering the sales floor, a young sailor approached asking for help putting together a wardrobe. With all other salesmen busy, Johnnie stepped up. <strong>$2,500 worth of merchandise later</strong>, the sailor was thrilled with his purchase.
          </p>
          <p className="italic text-[#7B1E2B] font-semibold">
            "As of today, you no longer work in the stockroom. You stay out here on the floor and sell."
          </p>
          <p className="text-sm mt-2 text-gray-600">- The Store Owner</p>
        </div>

        <p>
          From that moment, Johnnie immersed himself in the art of merchandising, mastering display styles and techniques, and understanding the business side of retail operations. The owner recognized his natural talent and provided him with a clothing allowance - including a suit, shirt, and his first bow tie.
        </p>

        <p className="text-xl font-serif text-[#001B2A] pt-4 border-t-2 border-[#E6D7B3]">
          <strong>Thus was born: Johnnie Mayo, The Bow Tie Guy</strong>
        </p>
      </div>
    </div>
  </div>
);
